import React from 'react';
import { IonLoading } from '@ionic/react';

const Loading: React.FC = () => {
  return <IonLoading isOpen={true} message="Loading..." className="authLoading" />;
};

export default Loading;
